import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { connect } from "react-redux";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {red, blue} from "@material-ui/core/colors";

const styles = theme => ({
  close: {
    padding: theme.spacing(1) / 2
  }
});

class RequestSnackbar extends React.Component {
  render() {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={this.props.isOpen}
        autoHideDuration={6000}
        onClose={this.props.closeSnackBar}
      >
        <SnackbarContent
          style={this.props.severity === "info" ? { backgroundColor: blue[600] } : { backgroundColor: red[600] } }
          onClose={this.props.closeSnackBar}
          message={this.props.message}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.props.closeSnackBar}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
      </Snackbar>
    );
  }
}

const mapStateToProps = state => {
  return {
    isOpen: state.requestReducer.isSnackbar,
    message: state.requestReducer.snackbarMessage,
    severity: state.requestReducer.severity
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeSnackBar: () => dispatch({ type: "CLOSE_SNACKBAR" })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestSnackbar);

// severity: "success", "info", "warning", "error"
RequestSnackbar.defaultProps = {
    severity: "info"
};

